export const messages = {
  en: {
    storeOrderCartManage: {
      search: {
        title: 'Search Conditions',
        cartId: 'Order Number',
        state: 'Select Status',
        prodName: 'Enter Product Name',
        shop: 'Select Shop'
      },
      list: {
        title: 'Order Information'
      },
      table: {
        cartId: 'Order Number',
        appName: 'Platform',
        shopName: 'Shop',
        cartType: 'Type',
        service: 'Service',
        goods: 'Goods',
        prodName: 'Name',
        cartNum: 'Quantity',
        personName: 'User Name',
        payPrice: 'Payment Amount',
        stateName: 'Order Status',
        createTime: 'Creation Time'
      },
      state: {
        unpurchased: 'Unpurchased',
        waitingDelivery: 'Waiting Delivery',
        waitingReceive: 'Waiting Receive',
        waitingComment: 'Waiting Comment',
        applyRefund: 'Apply Refund',
        refundSuccess: 'Refund Success',
        refunded: 'Refunded'
      },
      fetchError: 'Failed to fetch order list',
      fetchShopsError: 'Failed to fetch shops'
    }
  },
  zh: {
    storeOrderCartManage: {
      search: {
        title: '查询条件',
        cartId: '订单编号',
        state: '请选择状态',
        prodName: '请输入商品名称',
        shop: '请选择商铺'
      },
      list: {
        title: '订单信息'
      },
      table: {
        cartId: '订单号',
        appName: '平台',
        shopName: '商铺',
        cartType: '类型',
        service: '服务',
        goods: '商品',
        prodName: '名称',
        cartNum: '数量',
        personName: '用户名称',
        payPrice: '支付金额',
        stateName: '订单状态',
        createTime: '创建时间'
      },
      state: {
        unpurchased: '未购买',
        waitingDelivery: '待发货',
        waitingReceive: '待收货',
        waitingComment: '待评价',
        applyRefund: '申请退款',
        refundSuccess: '退货成功',
        refunded: '已退款'
      },
      fetchError: '获取订单列表失败',
      fetchShopsError: '获取商铺列表失败'
    }
  },
  'zh-TW': {
    storeOrderCartManage: {
      search: {
        title: '查詢條件',
        cartId: '訂單編號',
        state: '請選擇狀態',
        prodName: '請輸入商品名稱',
        shop: '請選擇商鋪'
      },
      list: {
        title: '訂單信息'
      },
      table: {
        cartId: '訂單號',
        appName: '平台',
        shopName: '商鋪',
        cartType: '類型',
        service: '服務',
        goods: '商品',
        prodName: '名稱',
        cartNum: '數量',
        personName: '用戶名稱',
        payPrice: '支付金額',
        stateName: '訂單狀態',
        createTime: '創建時間'
      },
      state: {
        unpurchased: '未購買',
        waitingDelivery: '待發貨',
        waitingReceive: '待收貨',
        waitingComment: '待評價',
        applyRefund: '申請退款',
        refundSuccess: '退貨成功',
        refunded: '已退款'
      },
      fetchError: '獲取訂單列表失敗',
      fetchShopsError: '獲取商鋪列表失敗'
    }
  }
}